/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartBarStackedH = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <style>{'.ico-chart-bar-stacked-h_svg__st0{fill:currentcolor}'}</style>
    <path
      className="ico-chart-bar-stacked-h_svg__st0"
      d="M4 20v-2h5v-2H4v-2h8v-2H4v-2h4V8H4V6h6V4H4V2H2v20h20v-2z"
    />
    <path
      className="ico-chart-bar-stacked-h_svg__st0"
      d="M11 4h5v2h-5zm2 8h3v2h-3zM9 8h12v2H9zm1 8h9v2h-9z"
    />
  </Icon>
);
export { SvgChartBarStackedH as ChartBarStackedH };
